import { BetslipType } from '../../../../../core/betslip-type';
import { ComboPreventionPreCheckError } from '../../../errors/pre-check/combo-prevention-pre-check-error';
import { BetslipTypeValidationContext } from '../../../models/models';
import { ComboPreventionValidator } from '../bets/combo-prevention.validator';

export abstract class BaseTypeComboPreventionValidator {
    constructor(private comboPreventionValidator: ComboPreventionValidator) {}

    validateComboPrevention(context: BetslipTypeValidationContext): ComboPreventionPreCheckError[] {
        const picks = context.selectedPicks;
        const betslipType = context.type;

        const comboPreventionRestrictions = this.comboPreventionValidator.getRestrictions(
            picks,
            betslipType === BetslipType.System,
            betslipType === BetslipType.Teaser,
        );

        return this.comboPreventionValidator.convertRestrictionsToErrors(comboPreventionRestrictions);
    }
}
